module.exports = function getResource(label, vars = []) {
    let resources = {
        seeAll: `See all ${vars[0]}`
    };

    return resources[label];
};
